module.exports = __webpack_public_path__ + "static/media/clock.e9b7e6b0.svg";